"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitcoinAmount = exports.Bitcoin = exports.BitcoinUnit = void 0;
const monetary_1 = require("../monetary");
/* Minimal currency definition */
exports.BitcoinUnit = {
    BTC: 8,
    Satoshi: 0,
};
exports.Bitcoin = {
    name: "Bitcoin",
    base: exports.BitcoinUnit.BTC,
    rawBase: exports.BitcoinUnit.Satoshi,
    units: exports.BitcoinUnit,
    humanDecimals: 8,
    ticker: "BTC"
};
class BitcoinAmount extends monetary_1.MonetaryAmount {
}
exports.BitcoinAmount = BitcoinAmount;
BitcoinAmount.from = monetary_1.generateFromConversions(exports.Bitcoin, exports.BitcoinUnit);
BitcoinAmount.zero = BitcoinAmount.from.BTC(0);
